exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.footer-subscribe[data-v-399d9985]::before {\n  content: '';\n  background: #000;\n  opacity: 0.6;\n  height: 100%;\n  width: 100%;\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n", ""]);

// exports
